<ng-container *ngIf="(sponsors | showAdBanner) || alwaysShow">
  <h2 *ngIf="!insetHeader && !hideHeader"
      class="{{colorScheme.transparentScheme.main}}"
      [class.light]="lightHeading">
    {{headerText}}
  </h2>
  <div #adContainer class="ad-campaign"
       [class.inset-header]="insetHeader"
       [class.small-campaign]="adCampaignService.campaign?.length > 1 || sponsors?.length > 1 || simple"
       [class.multiple]="adCampaignService.campaign?.length > 2 || sponsors?.length > 2"
       [class.scroll]="adCampaignService.campaign?.length > 3 || sponsors?.length > 3">
    <h3 *ngIf="insetHeader">{{headerText}}</h3>
    <button class="ad-campaign__nav-button before d-none d-md-flex"
            [class.hidden]="!scrolledEnd || adCampaignService.campaign?.length < 4  || sponsors?.length < 4"
            [ngStyle]="{ left: startButtonLeft }"
            (click)="toStart()">
      <mat-icon>navigate_before</mat-icon>
    </button>
    <ng-container *ngFor="let item of adCampaignService.campaign; let i = index">
      <a *ngIf="adCampaignService.canShow(item) || alwaysShow"
         class="ad-campaign__item" target="_blank" [href]="item.url">
        <lib-lazy-image [picture]="item.pictures[0]"
                        [alt]="item.name" [lazyLoad]="false"></lib-lazy-image>
      </a>
    </ng-container>
    <ng-container *ngIf="sponsors?.length && !adCampaignService.campaign?.length">
      <a *ngFor="let item of sponsors; let i = index"
         class="ad-campaign__item" target="_blank" [href]="item.url">
        <lib-lazy-image [picture]="item.pictures[0]"
                        [alt]="item.name" [lazyLoad]="false"></lib-lazy-image>
      </a>
    </ng-container>
    <button class="ad-campaign__nav-button next d-none d-md-flex"
            [class.hidden]="scrolledEnd || adCampaignService.campaign?.length < 4  || sponsors?.length < 4"
            (click)="toEnd()">
      <mat-icon>navigate_next</mat-icon>
    </button>
  </div>
</ng-container>
